import React from 'react';
import { moments, needs } from '../data/content';
const needColor = (label: string) => needs.find(need => need.label === label)?.color ?? '#d8b35a';
export function UseMoments() {
  return <section className="bg-night-panel" data-id="element-204" data-mp="2ty72p7xrkj6">
      <div className="mx-auto max-w-content px-5 py-14 sm:px-6 lg:py-24" data-id="element-205" data-mp="2uzr3j6xjhd1">
        <div className="mx-auto max-w-2xl text-center" data-id="element-206" data-mp="3uzbs42bbni2g">
          <h2 className="font-display text-[1.875rem] font-semibold leading-tight tracking-tight text-parchment sm:text-4xl" data-id="element-207" data-mp="vj5eyeta5mh3">
            Momentos para abrir tu Botiquín
          </h2>
          <p className="mt-4 font-sans text-base leading-relaxed text-parchment/70" data-id="element-208" data-mp="qm565w51q5ma">
            Situaciones de todos los días en las que una Palabra de Dios hace la diferencia.
          </p>
        </div>

        <ul className="mx-auto mt-10 grid max-w-5xl gap-x-10 border-t border-night-line md:grid-cols-2" data-id="element-209" data-mp="hpxlsipjwixa">
          {moments.map(moment => <li key={moment.title} className="border-b border-night-line py-6" data-id="element-210" data-mp="19hvd7xru5s71">
              <span className="inline-flex items-center gap-2 font-sans text-xs font-semibold text-parchment/60" data-id="element-211" data-mp="1pul3jqdmc1p5">
                <span aria-hidden="true" className="h-2 w-2 rounded-full" style={{
              backgroundColor: needColor(moment.need)
            }} data-id="element-212" data-mp="1uuhanyhm498x" />
                {moment.need}
              </span>
              <h3 className="mt-2 font-display text-xl font-semibold leading-snug text-parchment" data-id="element-213" data-mp="1l2bjus33jxvb">
                {moment.title}
              </h3>
              <p className="mt-1.5 font-sans text-[0.95rem] leading-relaxed text-parchment/70" data-id="element-214" data-mp="1c3zqiiauilz6">
                {moment.description}
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}